(function() {
  const swiperInstances = new Map();

  function initSlider(slider) {
    const swiperEl = slider.querySelector('.swiper');
    if (!swiperEl) return;

    if (swiperInstances.has(slider)) {
      swiperInstances.get(slider).destroy(true, true);
      swiperInstances.delete(slider);
    }

    const autoplayEnabled = swiperEl.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(swiperEl.dataset.autoplayDelay, 10) || 4000;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: autoplayEnabled
        ? { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      pagination: {
        el: slider.querySelector('.ctr-press__pagination'),
        clickable: true
      },
      navigation: {
        nextEl: slider.querySelector('.ctr-press__nav-next'),
        prevEl: slider.querySelector('.ctr-press__nav-prev')
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 0,
          loop: false,
          allowTouchMove: false,
          autoplay: false
        }
      }
    });

    swiperInstances.set(slider, swiper);
    return swiper;
  }

  function initAllSliders() {
    document.querySelectorAll('.ctr-press__slider').forEach(function(slider) {
      initSlider(slider);
    });
  }

  function destroySlider(slider) {
    if (swiperInstances.has(slider)) {
      swiperInstances.get(slider).destroy(true, true);
      swiperInstances.delete(slider);
    }
  }

  document.addEventListener('DOMContentLoaded', initAllSliders);

  document.addEventListener('shopify:section:load', function(event) {
    const slider = event.target.querySelector('.ctr-press__slider');
    if (slider) initSlider(slider);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const slider = event.target.querySelector('.ctr-press__slider');
    if (slider) destroySlider(slider);
  });

  document.addEventListener('shopify:block:select', function(event) {
    const slider = event.target.closest('.ctr-press__slider');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      const slide = event.target.closest('.swiper-slide');
      if (slide) {
        const index = Array.from(slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')).indexOf(slide);
        if (index !== -1) swiper.slideToLoop(index);
      }
    }
  });
})();